import { Box, Button, IconButton, Modal } from '@mui/material';
import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreateExchange from './Create';
import { ReactTable } from '@components';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { MRT_ToggleGlobalFilterButton } from 'material-react-table';
import { apiDeleteExchange, deleteExchange } from '@store';
import { showToast } from '@utils';

const Exchanges = () => {
    const dispatch = useDispatch();
    const { exchanges, isGetExchangesLoading } = useSelector(
        (state) => state.exchanges
    );

    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        setOpenModal(true);
    };
    const handleCloseModal = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpenModal(false);
        }
    };

    const handleDelete = useCallback(
        async (exchange) => {
            if (
                window.confirm('Are you sure you want to delete this exchange?')
            ) {
                const resp = await dispatch(apiDeleteExchange(exchange));
                if (resp?.meta?.requestStatus === 'fulfilled') {
                    dispatch(deleteExchange(exchange));
                    showToast('info', 'Exchange deleted successfully');
                } else if (resp?.meta?.requestStatus === 'rejected') {
                    showToast('error', resp.payload);
                } else {
                    showToast('error', 'Something went wrong');
                }
            }
        },
        [dispatch]
    );

    const columns = useMemo(
        () => [
            {
                header: 'Name',
                id: 'name',
                accessorFn: ({ name }) => name || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Country',
                id: 'country',
                accessorFn: ({ country }) => country || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Phone',
                id: 'phone',
                accessorFn: ({ phone }) => phone || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            },
            {
                header: 'Location',
                id: 'location',
                accessorFn: ({ location }) => location || '',
                Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>
            }
        ],
        []
    );

    const actionsMenu = useMemo(
        () =>
            ({ row }) =>
                [
                    <Button
                        variant="outlined"
                        color="error"
                        sx={{
                            p: 0,
                            m: 0,
                            borderColor: 'brown',
                            color: 'brown',
                            fontSize: '13px',
                            '&:hover': {
                                borderColor: 'brown',
                                color: 'white',
                                backgroundColor: 'brown'
                            }
                        }}
                        onClick={() => handleDelete(row?.original?.uuid)}
                    >
                        Delete
                    </Button>
                ],
        [handleDelete]
    );

    return (
        <Box>
            <Modal open={openModal} onClose={handleCloseModal} disableBackdropClick>
                <CreateExchange handleClose={handleCloseModal} />
            </Modal>
            <ReactTable
                renderToolbarInternalActions={({ table }) => (
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <MRT_ToggleGlobalFilterButton table={table} />
                        <IconButton
                            onClick={handleOpenModal}
                            title="Create Exchange"
                        >
                            <AddBoxOutlinedIcon />
                        </IconButton>
                    </div>
                )}
                headerText={'Exchanges'}
                columns={columns}
                data={exchanges || []}
                actions={actionsMenu}
                isLoading={isGetExchangesLoading}
            />
        </Box>
    );
};

export default Exchanges;
